import { apiService } from '../../../shared/services/apiServices';
import { EQUIPMENT_ERROR_MESSAGES } from '../errors/errorMessages';
import equipmentEndpoints from './equipmentEndpoints';

export interface PresignedUrlBatchRequest {
  paths: string[];
  generatePath?: boolean;
}

export interface PresignedUrlBatchResponse {
  entityId?: string;
  files: Array<{
    originalPath: string;
    path: string;
    url: string;
    resourceId: string;
  }>;
}

export const getPresignedUrlsBatch = async (
  request: PresignedUrlBatchRequest
): Promise<PresignedUrlBatchResponse> => {
  try {
    const result = await apiService.postAPI(
      equipmentEndpoints.PRESIGNED_URLS_BATCH,
      request
    );

    if (result.error) {
      throw new Error(EQUIPMENT_ERROR_MESSAGES.UNEXPECTED_ERROR);
    }

    return result.data as PresignedUrlBatchResponse;
  } catch (_error) {
    throw new Error(EQUIPMENT_ERROR_MESSAGES.UNEXPECTED_ERROR);
  }
};
